export class PLChangePassword {

    Ind: number;
    OrgCode: number;
    CityCode: number;
    UserId: number;
    LevelId: number;
    UserName: string;
    Password: string;
    ConfirmPassword: string;

}
